import * as React from 'react';

import type {OutcomeType} from 'nutshell-graphql-types';

import {FormTextAutomations} from '../../forms';

import {SalesAutomationEditorSidebar} from './sidebar/sales-automation-editor-sidebar';

type OwnProps = {
    entityId: string | null | undefined;
    parentId: OutcomeType;
    stagesetId: string;
    isNew: boolean;
};

type Props = OwnProps;

export class TextAutomationEditor extends React.PureComponent<Props> {
    sidebarFormSubmitBtnRef: HTMLInputElement | null | undefined;

    render() {
        const {isNew, ...restProps} = this.props;

        return (
            <SalesAutomationEditorSidebar
                onSave={this.handleSidebarFormSave}
                title={isNew ? 'New text message automation' : 'Edit text message automation'}
            >
                <FormTextAutomations
                    formSubmitBtnRef={(node) => {
                        this.sidebarFormSubmitBtnRef = node;
                    }}
                    {...restProps}
                />
            </SalesAutomationEditorSidebar>
        );
    }

    handleSidebarFormSave = () => {
        if (this.sidebarFormSubmitBtnRef) {
            this.sidebarFormSubmitBtnRef.click();
        }
    };
}
